
export interface PrintDto {
    id: number;
    type: CardType;
}


export enum CardType {
    DIRECT_ASSESSMENT = 'DIRECT_ASSESSMENT',
    PAYE_ASSESSMENT = 'PAYE_ASSESSMENT'
}
